export default {
	data: function () {
		return {
			moduleName: 'packages',
			detailPageRouteName: 'packageDetail',
			updateFields: [
				'name',
				'price',
				'enabled',
				'id_channels',
				'id_business_models',
				'id_operator',
				'type',
				'combination_with_basic',
				'combination_with_thematic',
				'include_in_report',
			],
			entity: {
				name: '',
				price: '0',
				channels: [],
				business_models: [{id: 0}],
				id_business_models: [0],
				id_operator: null,
				type: 'basic',
				combination_with_basic: false,
				combination_with_thematic: false,
				include_in_report: true
			},
			allChannels: [],
			selectedChannels: [],
			selectedChannelsToRemove: [],
			isPackageInAnyService: false,
		}
	},
	watch: {
		operatorIdComputed: {
			handler(newVal) {
				this.setBusinessModelByOperatorId(newVal, true)
			}
		}
	},
	computed: {
		packageTypeOptions() {
			return [
				{id: 'basic', text: this.$gettext('Základní')},
				{id: 'thematic', text: this.$gettext('Tématický')},
			]
		},
		selectedAssignedChannels() {
			if (this.selectedChannelsToRemove.length === 0) {
				return this.assignedChannelIds
			} else {
				return this._.filter(this.assignedChannelIds, function (id) {
					return !this._.includes(this.selectedChannelsToRemove, Number(id))
				}.bind(this))
			}
		},
		assignedChannelIds() {
			return this.entity.id_channels
		},
		isGlobalPackage() {
			return Number(this.entity.id_operator) === 0
		},
		operatorIdComputed: {
			get() {
				if (this.entity.id_operator === null) {
					return '0'
				} else {
					return this.entity.id_operator
				}
			},
			set(newValue) {
				this.setBusinessModelByOperatorId(newValue, true)
				this.entity.id_operator = newValue;
				let value = this.operatorIdComputed;

			}
		},
		packageTypeComputed: {
			get() {
				return this.entity.type
			},
			set(newValue) {
				if (newValue === 'basic') {
					this.entity.combination_with_basic = false
					this.entity.combination_with_thematic = false
				}
				this.entity.type = newValue
			}
		},
		allBusinessModelsWithUndefinedOption() {
			return this.prependWithUndefinedOptions([...this.businessModelOptions])
		}
	},
	methods: {
		prependWithUndefinedOptions(data) {
			data.unshift({'id': 0, 'text': this.$gettext('Nenastaven')})
			return data
		},
		prepareFormSubmitData(create = true) {
			if (this.entity.price === '') {
				this.entity.price = '0'
			}

			let data = {
				name: this.entity.name,
				price: this.entity.price,
				type: this.entity.type,
				id_channels: this.entity.id_channels,
				include_in_report: this.entity.include_in_report,
			}

			if (this.entity.type === 'basic') {
				data.combination_with_basic = this.entity.combination_with_basic
				data.combination_with_thematic = this.entity.combination_with_thematic
			}

			if (this.$_readActionAllowedAllOrOwnAndGlobal) {
				if (create) {
					if (Number(this.entity.id_operator) > 0) {
						data.id_operator = this.entity.id_operator
					}
				}
				data.id_business_models = this.entity.id_business_models
			}

			return data
		},
		_beforeCreateEntityActions(data){
			return this.prepareFormSubmitData(true);
		},
		_beforeUpdateEntityActions(data){
			return this.prepareFormSubmitData(false);
		},
		_processDetailErrorMessage(error) {
			let nameError = null
			let combinationError = null
			let businessModelError = null

			this._.forEach(error['validation_errors'], function (errorMessage) {
				if (this._.includes(errorMessage, "Channel package with given name") &&
					this._.includes(errorMessage, 'already exists')) {
					nameError = this.$gettext("Název musí být unikátní")
				}
				if (errorMessage === "Channel package type cannot be updated when it is being used by subscriber(s).") {
					combinationError = this.$gettext("Typ balíčku se nemůže měnit, když je balíček přiřazený odběrateli.")
				}
				if (this._.includes(errorMessage, "type change is not consistent with other channel packages in service")) {
					combinationError = this.$gettext("Typ balíčku se nemůže měnit, již se používá v kombinaci s jinými balíčky.")
				}
				if (this._.includes(errorMessage, "Cannot update channel package's business models to given values.")) {
					businessModelError = this.$gettext("Business modely musí být v konzistenci se službami")
				}
			}.bind(this))

			if (!this.entity.name) {
				nameError = this.$gettext('Zadejte název')
			} else if (this.entity.name.length < 2) {
				nameError = this.$gettext('Název musí obsahovat min. 2 znaky')
			}

			if (nameError !== null) {
				this.setFieldInvalid('packagenameref', true, nameError)
			} else {
				this.setFieldInvalid('packagenameref')
			}

			if (combinationError !== null) {
				this.setFieldInvalid('packagetyperef', true, combinationError)
			} else {
				this.setFieldInvalid('packagetyperef')
			}

			if (this.entity.id_business_models.length === 0 || (
				this.entity.id_business_models.length === 1 && Number(this.entity.id_business_models[0]) === 0)
			) {
				businessModelError = this.$gettext('Zadejte business model')
			}

			if (businessModelError) {
				this.setFieldInvalid('packagebusinessmodelref', true, businessModelError)
			} else {
				this.setFieldInvalid('packagebusinessmodelref')
			}

			return error['error_message']
		},
		reset() {
			this.setFieldInvalid('packagenameref')
			this.setFieldInvalid('packagetyperef')
			this.setFieldInvalid('packagebusinessmodelref')
		},
		redirect() {
			this.$router.push({name: 'packages'})
		},
	}
}



// WEBPACK FOOTER //
// ./src/components/views/packages/mixins/packages.js